import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

interface BenefitCardProps {
  title: string;
  description: string;
  emoji: string;
}

const CardContainer = styled(motion(Box))(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(3),
  background: 'rgba(26, 26, 46, 0.6)',
  backdropFilter: 'blur(5px)',
  borderRadius: theme.spacing(2),
  border: '1px solid rgba(138, 43, 226, 0.2)',
  transition: 'all 0.3s ease',
  height: '100%',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: 'linear-gradient(0deg, transparent, transparent 30%, rgba(0, 255, 255, 0.3))',
    transform: 'rotate(-45deg)',
    transition: 'all 0.5s ease',
    opacity: 0,
  },
  '&:hover': {
    background: 'rgba(26, 26, 46, 0.8)',
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 20px rgba(0, 255, 255, 0.3)',
    border: '1px solid rgba(0, 255, 255, 0.3)',
    '&::before': {
      opacity: 1,
      transform: 'rotate(-45deg) translateY(100%)',
    },
  }
}));

const EmojiContainer = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  background: 'rgba(26, 26, 46, 0.6)',
  border: '2px solid rgba(138, 43, 226, 0.2)',
  fontSize: '24px',
  transition: 'all 0.3s ease',
  '&:hover': {
    border: '2px solid rgba(0, 255, 255, 0.3)',
    boxShadow: '0 0 15px rgba(0, 255, 255, 0.3)',
    background: 'rgba(26, 26, 46, 0.8)',
  }
}));

const BenefitCard: React.FC<BenefitCardProps> = ({
  title,
  description,
  emoji
}) => {
  return (
    <CardContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <EmojiContainer>
        {emoji}
      </EmojiContainer>
      
      <Typography 
        variant="h6" 
        sx={{ 
          color: '#00FFFF',
          fontWeight: 600,
          mb: 2,
        }}
      >
        {title}
      </Typography>
      
      <Typography 
        variant="body1" 
        sx={{ 
          color: 'rgba(255, 255, 255, 0.8)',
          lineHeight: 1.6
        }}
      >
        {description}
      </Typography>
    </CardContainer>
  );
};

export default BenefitCard; 